import * as moment from "moment";

export class ProgressHeaderController {
    startedOn: string;
    completedOn: string;
    totalSchools: number;
    totalSchoolsCompleted: number;
    isTest: boolean;
    isImportComplete: boolean;

    getImportDate(date): string {
        const momentLocal = (moment as any).tz(date, "UTC").local();
        return `${momentLocal.format("MMM DD YYYY")} at ${momentLocal.format("hh:mm A")}`;
    }

    getImportedText(): string {
        return this.isTest ? "Test import in progress." : "Import in progress.";
    }

    getCompletedText() { return this.isTest ? "Test import" : "Import"; }
    
    isWaiting() : boolean {
        return (this.totalSchoolsCompleted == null || this.isImportComplete == null) ||
            (this.totalSchoolsCompleted === 0 && !this.isImportComplete);
    }

    isInProgress(): boolean {
        return this.totalSchoolsCompleted > 0 && !this.isImportComplete;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/progress-header/progress-header.controller.ts